export default "__VITE_ASSET__gTQr9Pwd__"